import { RouteRecordRaw } from "vue-router";

const fallbackRoute: Array<RouteRecordRaw> = [
    {
      path: "/:pathMatch(.*)*",
      redirect: "/",
    },
  ];


export default fallbackRoute;